import { latestDataPointGroupUpdateDate, latestDataPointGroupUpdateDateTime } from '../../DataPointGroup';
import { decayedLimit, isDecayed } from '../../util';
import { AmountSumTableItem, AmountSumTableItemProps } from './Table';
import { PersonalPropertyItem } from '../../generated/graphql';

interface PersonalPropertyItemSumTableItemProps
  extends Pick<
    AmountSumTableItemProps,
    'amount' | 'className' | 'subtitle' | 'withChevron' | 'motionProps' | 'contentPrefix'
  > {
  itemTitle?: string;
  personalPropertyItem: PersonalPropertyItem;
  onItemClicked?: (a: { personalPropertyItem: PersonalPropertyItem }) => void;
}

export const PersonalPropertyItemSumTableItem = ({
  personalPropertyItem,
  onItemClicked,
  ...props
}: PersonalPropertyItemSumTableItemProps) => {
  return (
    <AmountSumTableItem
      contentPrefix={props.contentPrefix}
      motionProps={props.motionProps}
      key={personalPropertyItem.id}
      title={props.itemTitle ?? personalPropertyItem.name}
      dataTestID={personalPropertyItem.name}
      withChevron={props.withChevron ?? !!onItemClicked}
      interactive={!!onItemClicked}
      amount={personalPropertyItem.ownedValue}
      className={props.className}
      onClick={onItemClicked ? () => onItemClicked({ personalPropertyItem }) : undefined}
      lastUpdated={latestDataPointGroupUpdateDateTime(personalPropertyItem.value)}
      onKeyDown={
        onItemClicked
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onItemClicked({ personalPropertyItem });
              }
            }
          : undefined
      }
      decayed={isDecayed(latestDataPointGroupUpdateDate(personalPropertyItem.value), decayedLimit.PersonalPropertyItem)}
      {...props}
    />
  );
};
